import React from 'react';

import classNames from 'classnames';

import { iconByVariant, iconClassNamesBySize, iconClassNamesByVariant } from './constants';

import type { Size, Variant } from './types';

type Props = {
  variant: Variant;
  size: Size;
  customIcon?: React.ReactNode;
};

export const Icon: React.FC<Props> = ({ customIcon, variant, size }) => (
  <span
    className={classNames(
      'shrink-0 flex items-center',
      iconClassNamesByVariant[variant],
      iconClassNamesBySize[size],
    )}
  >
    {customIcon || iconByVariant[variant]}
  </span>
);
